/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Issue_Quantity_Without_LineInputs */

const en_claim_issue_quantity_without_line = /** @type {(inputs: Claim_Issue_Quantity_Without_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Units go with a line of the order.`)
};

/**
* | output |
* | --- |
* | "Units go with a line of the order." |
*
* @param {Claim_Issue_Quantity_Without_LineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_issue_quantity_without_line = /** @type {((inputs?: Claim_Issue_Quantity_Without_LineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Issue_Quantity_Without_LineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_issue_quantity_without_line(inputs)
});